import React, {useEffect, useState} from "react";
import {Box, Button, FormControl, Grid, MenuItem, Select, Typography} from "@material-ui/core";
import moment from "moment/moment";
import {makeStyles, Theme} from "@material-ui/core/styles";

interface IDay {
    date: string,
    timeslots: string[],
}

interface AppointmentTimeProps {
    selectedDate?: string,
    setSelectedDate?: (string) => void,
    schedulingDays?: IDay[],
    pickedTimeSlot: string,
    setPickedTimeSlot: (string) => void,
}

const useStyle = makeStyles((theme: Theme) => ({
    dayContainer: {
        "& + &": {
            marginLeft: 22,
        },
    },
    date: {
        fontWeight: "bold",
        fontSize: 20,
        verticalAlign: "center",
    },
    dataContainer: {
        rowGap: 20,
        padding: "10px 0",
        marginTop: "20px",
    },
    dataWrapper: {
        rowGap: 35,
    },
    select: {
        minWidth: 300,
        boxSizing: "border-box",
        verticalAlign: "center",
        padding: "0px",
        "&.MuiFilledInput-underline:before": {
            borderBottom: "none"
        },
    },
    formControl: {
        minWidth: 300,
        boxSizing: "border-box",
        verticalAlign: "center",
        padding: "0px",
        ".MuiInputBase-formControl:hover:before": {
            borderBottom: "none"
        },
        ".MuiInputBase-formControl:hover": {
            backgroundColor: "#d3d3d3",
        },
    },
    selectMenu: {
        fontSize: 20,
        minWidth: "200px",
        borderRadius: 10,
        ".dropdown-option": {
            fontSize: 20,

            ".MuiSelect-select": {
                padding: 0,
            }
        },
        root: {
            fontSize: 20
        },
    }
}));

const useStyles = makeStyles(theme => ({
    filled: {
        paddingTop: "10px"
    },
    selectMenu: {
        fontSize: 20,
        minWidth: "200px",
        borderRadius: 10,
        ".dropdown-option": {
            fontSize: 20,

            ".MuiSelect-select": {
                padding: 0,
            }
        },
        root: {
            fontSize: 20
        },
    }
}));

const AppointmentTime: React.FC<AppointmentTimeProps> = (
    {
        selectedDate,
        setSelectedDate,
        schedulingDays,
        pickedTimeSlot,
        setPickedTimeSlot,
    }) => {
    const classes = useStyle();
    const styles = useStyles();
    const [timeslots, setTimeSlots] = useState([]);

    useEffect(() => {
        if(timeslots.length) {
            setPickedTimeSlot(timeslots[0]);
        }
    }, [selectedDate, timeslots]);

    useEffect(() => {
        if (selectedDate && schedulingDays.length) {
            const availableTimeslots = schedulingDays.find(({date}) => date === selectedDate).timeslots;
            setTimeSlots([...availableTimeslots]);
        }
    }, [selectedDate, schedulingDays]);

    useEffect(() => {
        if (!selectedDate && schedulingDays.length) {
            setSelectedDate(schedulingDays[0].date);
        }
    }, [schedulingDays]);

    return (
        <>
            <Grid item>
                <Typography variant="h3" align="left">
                    Select desired appointment type
                </Typography>
            </Grid>
            <Grid item>
                <Box display="flex">
                    {(() => {
                        return schedulingDays.slice(0, 7).map((
                            {
                                date,
                                timeslots
                            }, i) => {
                            const selected = date === selectedDate;
                            return (
                                <Button
                                    key={i}
                                    color="secondary"
                                    variant={selected ? "contained" : "outlined"}
                                    onClick={() => setSelectedDate(date)}
                                    className={`${classes.dayContainer}`}
                                >
                                    {moment(date).format("ddd")}
                                </Button>);
                        }
                        );
                    })()}
                </Box>
            </Grid>
            <Grid item>
                <Box>
                    <FormControl
                        variant="filled"
                        className={classes.formControl}
                    >
                        <Select
                            onChange={(e) => {
                                setPickedTimeSlot(e.target.value);
                            }}
                            margin="dense"
                            value={pickedTimeSlot}
                            className={classes.select}
                            classes={styles}
                        >
                            {timeslots &&
                            timeslots.map(
                                (time, i) =>
                                    <MenuItem
                                        value={time}
                                        key={i}
                                        className="dropdown-option"
                                    >
                                        {moment(time).format("ddd, MMM D, YYYY h:mm a")}
                                    </MenuItem>
                            )
                            }
                        </Select>
                    </FormControl>
                </Box>
            </Grid>
        </>
    );
};
export default AppointmentTime;
